module.exports = __webpack_public_path__ + "img/img3.17f2aea0.svg";